import { render, staticRenderFns } from "./GarageBidForm.vue?vue&type=template&id=0ec581a9"
import script from "./GarageBidForm.vue?vue&type=script&lang=js"
export * from "./GarageBidForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports